import React from "react";
import { Box, Typography, LinearProgress } from "@mui/material";

/** Green gradient bar used during plan initialization (plan details + MCR Import). */
export const PLAN_INIT_PROGRESS_BAR_SX = {
  height: 8,
  borderRadius: 2,
  backgroundColor: "#f3f5f7",
  "& .MuiLinearProgress-bar": {
    background: "linear-gradient(90deg, #A0DE41, #83D259, #68C880, #59C1B6)",
  },
};

/** Subtle opacity pulse on status message text while plan is still running. */
export const PLAN_INIT_MESSAGE_PULSE_SX = {
  animation: "planInitMessagePulse 1.4s ease-in-out infinite",
  "@keyframes planInitMessagePulse": {
    "0%, 100%": { opacity: 1 },
    "50%": { opacity: 0.45 },
  },
};

const LoadingScreen = ({ position = "relative", title = "Loading..." }) => {
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        position: position,
        top: 0,
        left: 0,
        paddingTop: "50px",
        m: "auto",
        width: "100%",
        height: "100%",
        zIndex: 29,
        backgroundColor: "transparent",
      }}
    >
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
        }}
      >
        <LinearProgress
          variant="indeterminate"
          sx={{
            width: "400px",
            marginBottom: "16px",
            ...PLAN_INIT_PROGRESS_BAR_SX,
          }}
        />
        <Typography
          variant="h5"
          className="!text-base !leading-[24px] text-[#212B36] text-center"
        >
          <span dangerouslySetInnerHTML={{ __html: title }} />
        </Typography>
      </Box>
    </Box>
  );
};

export default LoadingScreen;
